import { AxiosBuilder } from "@/core/services/axios-builder.service";
import { CIRX_ANONYMOUS_USER, CIRX_MODULE, CIRX_TOKEN } from "@/core/constants/api";
import { getCurrentDomain, isPublicApp } from "@/core/services/domain.service";
import Cookie from "@/assets/js/components/cookie";
import identificationService from "@/core/services/identification.service";

export class ApiFactory {
  static cirxToken = "";
  static bearerToken = "";
  static cirxModule = "";

  /**
   * @param {string} baseURL
   * @return {AxiosInstance}
   */
  static getDefaultApi(baseURL) {
    const builder = this.getDefaultApiBuilder(baseURL);
    builder.setRequestHandler(this._defaultRequestHandler);
    return builder.getApi();
  }

  /**
   * @param {string} baseURL
   * @return {AxiosInstance}
   */
  static getNewAuthentificationApi(baseURL) {
    const builder = this.getDefaultApiBuilder(baseURL);
    builder.setRequestHandler((request) => request);
    return builder.getApi();
  }

  /**
   * @param {string} baseURL
   * @return {AxiosBuilder}
   */
  static getDefaultApiBuilder(baseURL) {
    const builder = new AxiosBuilder(baseURL)
      .setHeader("Content-Type", "application/json")
      .setErrorHandler(this._defaultErrorHandler);

    if (this.cirxToken) {
      builder.setHeader(CIRX_TOKEN, this.cirxToken);
      builder.setHeader(CIRX_MODULE, this.cirxModule);
    } else if (this.bearerToken) {
      builder.setHeader("Authorization", `Bearer ${this.bearerToken}`);
    }

    return builder;
  }

  /**
   * Web circuit: if the anonymous token is expired, ask for a new one
   *
   * @param {object} request
   *
   * @return {object}
   */
  static async _defaultRequestHandler(request) {
    if (isPublicApp() && !Cookie.getCookie(CIRX_ANONYMOUS_USER)) {
      await identificationService.getAnonymousUserWithORD(getCurrentDomain());
      request.headers.Authorization = `Bearer ${Cookie.getCookie(CIRX_ANONYMOUS_USER)}`;
    }

    return request;
  }

  static async _defaultErrorHandler(error) {
    throw error;
  }
}
